/**
 * Pure selectors for cart-shaped collections.
 *
 * Independent of any store/library — accept an array, return a number. Use
 * with Zustand by composing inside the store's `selectXxx` selector:
 *
 *   export const selectFnbTotal = (s: KioskState) => cartTotal(s.fnbCart);
 */

interface PricedQuantity {
  price: number;
  quantity: number;
}

export function cartTotal(items: readonly PricedQuantity[]): number {
  return items.reduce((sum, i) => sum + i.price * i.quantity, 0);
}

export function cartCount(items: readonly PricedQuantity[]): number {
  return items.reduce((sum, i) => sum + i.quantity, 0);
}
